import {Component, OnInit} from '@angular/core';
import {Carousel, Carousels} from "../../shared/models/carousel.model ";
import {SwiperConfigInterface} from "ngx-swiper-wrapper";
import {ActivatedRoute} from "@angular/router";
import {NewsItems} from "../../news/models/news-item.model ";
import {EnvService} from "../../shared/services/env.service";

@Component({
    selector: 'home-homepage',
    templateUrl: './homepage.component.html',
    styleUrls: ['./homepage.component.scss']
})
export class HomepageComponent implements OnInit {

    public carousels: Carousels = [];

    public bannerCarouselConfig: SwiperConfigInterface = {
        speed: 1500,
        direction: 'horizontal',
        slidesPerView: 1,
        loop: true,
        loopAdditionalSlides: 2,
        autoplay: {
            delay: 3500,
            disableOnInteraction: true
        },
    };
    public bannerCarousel: Carousel = null;

    public brandsCarousel: Carousel = null;

    public newsItems: NewsItems;

    constructor(
            public envService: EnvService,
            private route: ActivatedRoute
    ) {
    }

    public ngOnInit() {
        this.route.data.subscribe(data => {
            if (data.hasOwnProperty('carouselsResult')) {
                this.carousels = data.carouselsResult;

                this.bannerCarousel = this.getCarousel('homepage_header');
                this.brandsCarousel = this.getCarousel('homepage_brands_finisher');
            }

            if (data.hasOwnProperty('newsItemsResult')) {
                this.newsItems = data.newsItemsResult;
            }
        });
    }

    public getBrandCarouselCount(): number {
        let carouselCids = [
            'homepage_brands_insulator',
            'homepage_brands_finisher',
            'homepage_brands_plasterer',
            'homepage_brands_painter',
            'homepage_brands_tiler',
            'homepage_brands_fire_applicator',
        ];

        return this.carousels.filter((carousel: Carousel) => carouselCids.indexOf(carousel.cid) > -1).length;
    }

    public hasCarousel(carouselCid: string): boolean {
        if (this.carousels) {
            let carousel = this.carousels.find((carousel: Carousel) => carousel.cid === carouselCid);

            if (carousel) {
                return true;
            }
        }

        return false;
    }

    public selectFunction(carouselCid: string): void {
        this.brandsCarousel = this.getCarousel(carouselCid);
    }

    public getCarousel(cid: string): Carousel {
        if (this.carousels) {
            for (let carousel of this.carousels) {
                if (carousel.cid === cid) {
                    return carousel;
                }
            }
        }

        return null;
    }
}
